<template lang="pug">
  div.bg
    div.container
      footer.columns
        div.column
          | ecoinvent
          br
          | Technoparkstrasse 1
          br
          | 8005 Zurich
          br
          | Switzerland
        div.column
          div.columns.is-mobile.is-centered
            div.column.is-narrow
              | +41 44 500 42 58
              br
              a(href="mailto:support@ecoinvent.org")
                b-icon(icon="envelope")
                span(style="margin-left: 0.3rem;") Email
              br
              router-link(to="/login/register") {{ $t('Register') }}
        div.column
          div.is-pulled-right
            a(href="https://www.ecoinvent.org/disclaimer/") {{ $t('Disclaimer') }}
            br
            a(href="https://www.ecoinvent.org/privacy-policy-eula/") GDPR&amp;EULA
            br
            a(href="https://www.ecoinvent.org/imprint/") {{ $t('Imprint') }}
</template>

<script>
export default {
  name: 'EcoinventFooter'
}
</script>

<style lang="scss" scoped>
.columns:last-child {
  margin-bottom: 0;
  padding-top: 0.5rem;
}

div.bg {
  background-color: #282828;
  background-image: linear-gradient(to top, #282828, #535353)
}
footer {
  a {
    color: #fff;
    &:hover {
      color: #282828;
    }
  }
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/EcoinventFooter.vue